import React, {Component} from 'react';
import classes from './Search.css';
import Spinner from '../../UI/Spinner/Spinner';
import SearchWindow from '../Search/SearchWindow/SearchWindow';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import {ADVANCE_SEARCH_TYPE, ID_TYPES_REVERSED, LS_ADVANCE_SEARCH_KEY } from '../../shared/Constants';


export class Search extends Component {

    state = {
        searchResult: null,
        localStorageSearchRequest: localStorage.getItem(LS_ADVANCE_SEARCH_KEY) !== null ? JSON.parse(atob(localStorage.getItem(LS_ADVANCE_SEARCH_KEY))) : null
    }

    componentDidMount() {
        this.clearSearch();
        this.restorePersistedSearch();
        window.scrollTo(0, 0);
    }

    restorePersistedSearch = () => {
        this.props.persistedSearchRequest && this.props.doSearch(this.props.persistedSearchRequest);
    }

    /*
        Only the in-memory request is replayed into the form on mount, so a page reload
        starts from a clean form. The local storage copy is reserved for back navigation.
    */
    getInitialSearchRequest = () => {
        return this.props.persistedSearchRequest;
    }

    setSearchResults =()=>{
        this.state.localStorageSearchRequest && this.props.doSearch(this.state.localStorageSearchRequest)
    }

    clearSearch = () => {
        this.props.resetSearchResults();
        this.props.setError(null);
    }

    clearPersistedSearch = () => {
        this.props.clearPersistedSearchRequest(ADVANCE_SEARCH_TYPE);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.loading && !this.props.loading) {
            this.persistSearchRequest();
        }
        // If the length of the result is 1 then we redirect this then we auto select the first item.
        this.props.searchResult && this.props.searchResult.length === 1 && !this.props.loading && prevProps.loading && this.memberSelectionHandler(this.props.searchResult[0])
    }

    /*
        A single result navigates straight to the member page, so only a request that
        yields a result list is worth replaying when the agent comes back to this tab.
    */
    persistSearchRequest = () => {
        const hasResultList = this.props.searchResult && this.props.searchResult.length > 1;
        if (hasResultList && this.props.searchCriteria) {
            this.props.setPersistedSearchRequest(ADVANCE_SEARCH_TYPE, this.props.searchCriteria);
        } else {
            this.clearPersistedSearch();
        }
    }

    searchToggleHandler =() => {}

    searchHandler = (data) => {
        // console.log("[Search] SearchHandler - request data - ", data);
        this.props.doSearch(data);
    }

    memberSelectionHandler = (data, index) => {
        // console.log("[Search] memberSelectionHandler", data);
        this.props.resetSearchResults();
        this.props.history.push({
            pathname:`/member/${btoa(data.uuid?data.uuid:data.id)}/${ID_TYPES_REVERSED[data.idType]?ID_TYPES_REVERSED[data.idType]:data.idType}`,
            state: {idType: ID_TYPES_REVERSED[data.idType]?ID_TYPES_REVERSED[data.idType]:data.idType}
        });
    }

    errorHandler = (errObj) => {
        this.props.setError(errObj);
        // this.setState({error: errObj});
    }

    render () {

        // console.log("[Search] render - props search result", this.props.displayMessage);

        let showWindow = null;

        showWindow = <SearchWindow
            quickSearch = {false}
            searchResult = {this.props.searchResult}
            searched = {this.searchHandler}
            error={this.props.error}
            errorHandler={this.errorHandler}
            selected={this.memberSelectionHandler}
            clearSearch={this.clearSearch}
            clearPersistedSearch={this.clearPersistedSearch}
            displayMessage={this.props.displayMessage}
            initialSearch={this.getInitialSearchRequest()}
            backNavigationSearch={this.state.localStorageSearchRequest}
            setSearchResults={this.setSearchResults}
            searchDataLimitPerPage={25}
        />

        const showSpinner = this.props.loading? <Spinner/>: null;

        return(
            <div className={classes.Search}>
                {showWindow}
                {showSpinner}
            </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        searchResult: state.search.searchResults,
        // selectedMember: state.member.selectedMember,
        loading: state.search.loading,
        error: state.search.error,
        displayMessage: state.search.displayMessage,
        searchCriteria: state.search.searchCriteria,
        persistedSearchRequest: actions.getPersistedSearchRequest(state, ADVANCE_SEARCH_TYPE)
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        doSearch: (searchCriteria, userType) => dispatch(actions.doSearch(searchCriteria, userType)),
        resetSearchResults: () => dispatch(actions.resetSearchResults()),
        selectMember: (selectedMember) => dispatch(actions.selectMember(selectedMember)),
        setError: (error) => dispatch(actions.setError(error)),
        setPersistedSearchRequest: (searchType, request) => dispatch(actions.setPersistedSearchRequest(searchType, request)),
        clearPersistedSearchRequest: (searchType) => dispatch(actions.clearPersistedSearchRequest(searchType)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);